import * as api from '../api/bppRendition';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const FETCH_CONFIGURATIONS = createRequestTypes(
  'BPP_RENDITION/FETCH_CONFIGURATIONS',
);

export const fetchConfigurations = makeApiActionCreatorV3(
  api.fetchConfigurations,
  FETCH_CONFIGURATIONS[START],
  FETCH_CONFIGURATIONS[SUCCESS],
  FETCH_CONFIGURATIONS[ERROR],
);

export const UPDATE_CONFIGURATION = createRequestTypes(
  'BPP_RENDITION/UPDATE_CONFIGURATION',
);

export const updateConfiguration = makeApiActionCreatorV3(
  api.updateConfiguration,
  UPDATE_CONFIGURATION[START],
  UPDATE_CONFIGURATION[SUCCESS],
  UPDATE_CONFIGURATION[ERROR],
);

export const FETCH_UI_OPTIONS = createRequestTypes(
  'BPP_RENDITION/FETCH_UI_OPTIONS',
);

export const fetchUIOptions = makeApiActionCreatorV3(
  api.fetchUIOptions,
  FETCH_UI_OPTIONS[START],
  FETCH_UI_OPTIONS[SUCCESS],
  FETCH_UI_OPTIONS[ERROR],
);

export const FETCH_PROPERTY_BPP_RENDITION_LOAD_DATA = createRequestTypes(
  'BPP_RENDITION/FETCH_PROPERTY_BPP_RENDITION_LOAD_DATA',
);

export const fetchPropertyBPPRenditionLoadData = makeApiActionCreatorV3(
  api.fetchPropertyBPPRenditionLoadData,
  FETCH_PROPERTY_BPP_RENDITION_LOAD_DATA[START],
  FETCH_PROPERTY_BPP_RENDITION_LOAD_DATA[SUCCESS],
  FETCH_PROPERTY_BPP_RENDITION_LOAD_DATA[ERROR],
);